<template>
  <div style="font-size: 16rem;">
    <div class="horizontal" style="overflow: auto;padding: 0 375rem;">
      <div v-if="loading" style="margin:20rem;">视频加载中...</div>
      <div v-for="(item, index) in video_list" :key="index" style="margin:20rem;" @click="video_idx=index">
        <div style="width:240rem;height:160rem;border-radius: 15rem;border: #999999 solid 1rem;background: #f6f6f6;position: relative;">
          <img style="display:block; height: 160rem;margin: auto;" v-bind:src="item.image_url">
          <div style="position: absolute;left:0;top:0;right:0;bottom: 0; background: rgba(100,100,100,0.2);border-radius: 15rem;">
            <img v-if="item.status==1" style="margin:60rem auto;display: block; width:40rem; height:40rem;" src="../assets/zsp/floatplay2.png" @click="playVideo(index)">
            <img v-if="item.status==-1" class="waitingImg" src="../assets/zsp/ic_loading.png">
            <img v-if="item.status==0" style="margin:60rem auto;display: block; width:40rem; height:40rem;" src="../assets/zsp/talkingface-icon6.png">
          </div>
          <div v-if="video_idx==index" style="position: absolute;right:8rem;bottom: 8rem;" class="horizontal">
            <img v-if="item.status>=0" style="display:block;width:30rem;height:30rem;z-index: 999;" src="../assets/zsp/talkingface-icon4.png" @click="showDelPanel = true">
            <img v-if="item.status==1" style="display:block;width:30rem;height:30rem;z-index: 999;margin-left: 8rem;" src="../assets/zsp/talkingface-icon5.png" @click="downVideo">
            <div v-if="item.status==-1" style="color:green;">约需{{ waiting_time }}秒</div>
          </div>
          <div v-if="item.status==1" style="position: absolute;right:8rem;top: 8rem;color:#444444;font-weight: bolder;">{{ item.duration }}秒</div>
        </div>
        <div class="title">{{ item.title }}</div>
      </div>
    </div>
    <div class="mask" v-if="showDelPanel">
      <div style="background: #f6f6f6;border-radius: 15rem;padding: 25rem;font-size: 20rem;">
        <div style="color:#666666;padding-bottom: 20rem;">确定删除该视频吗?</div>
        <div class="horizontal">
          <div style="text-align: center; background: #666666;padding: 10rem 20rem;border-radius: 10rem;color:white;" @click="showDelPanel=false">取消</div>
          <div style="margin-left:40rem;text-align: center; background: #666666;padding: 10rem 20rem;border-radius: 10rem;color:white;" @click="confirmDel">确认</div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="showPlayerPanel">
      <div style="background:white;border-radius: 15rem;">
        <img style="float:right;display:block;width:20rem;height:20rem;margin:10rem;" src="../assets/zsp/close_x.png" @click='showPlayerPanel=false'/>
        <div style="width: 400rem;height: auto;margin:35rem 10rem;">
          <video-player class="video-player vjs-custom-skin"
            :playsinline="true"
            :options="playerOptions">
          </video-player>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { saveAs } from "file-saver"
import { PLAY_OPTION } from './util'

export default {
  props: {
    userID: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      video_list:[],
      video_idx:-1,
      showPlayerPanel:false,
      showDelPanel:false,

      waiting_num:-1,
      waiting_time:-1,

      playerOptions:PLAY_OPTION,

      loading:false
    }
  },
  created() {
    document.title = ''
    this.getRouterData()
  },
  destroyed() {
    //
  },
  methods: {
    getRouterData() {
      this.loadVideoList()
    },
    async loadVideoList() {
      if(this.loading) return
      this.loading = true

      let request_data = {
        'type': 'talkingface_video_list',
        'data': {
          'user_id': this.userID
        }
      }
      await axios.post('https://caixiaowen.com/zsp', JSON.stringify(request_data))
        .then((result) => {
          console.log(result.data)
          this.video_list = result.data.video_list
          this.checkResult()
          this.loading = false
        }).catch((error) => {
          console.log(error)
          this.loading = false
        })
    },
    confirmDel(){
      let request_data = {
        'type': 'talkingface_update_result',
        'data': {
          'user_id': this.userID,
          'sid': this.video_list[this.video_idx].sid,
          'del': 1
        }
      }
      axios.post('https://caixiaowen.com/zsp', JSON.stringify(request_data))
      .then((result) => {
        console.log(result.data)
        this.video_list.splice(this.video_idx, 1)
        this.showDelPanel = false
        this.video_idx=-1
      }).catch((error) => {
        console.log(error)
      })
    },
    downVideo() {
      fetch(this.video_list[this.video_idx].video_url)
        .then(response => response.blob())
        .then(blob => {
          saveAs(blob, "download.mp4");
        });
    },
    playVideo(index) {
      if(this.video_list[index].status==1) {
        this.showPlayerPanel = true
        this.playerOptions.sources=[{
          type: "video/mp4",
          src: this.video_list[index].video_url
        }]
      } else if(this.video_list[index].status==0) {
        alert("生成失败了, 请检查上传内容, 或联系客服处理")
      } else if(this.video_list[index].status==-1) {
        //
      }
    },
    checkResult() {
      var sid = ""
      for(var i = 0;i<this.video_list.length;i+=1){
        if(this.video_list[i].status==-1){
          sid = this.video_list[i].sid
          break
        }
      }
      if(sid == "") return

      let request_data = {
        'type': 'talkingface_check_result',
        'data': {
          'user_id': this.userID,
          'sid': sid
        }
      }
      axios.post('https://caixiaowen.com/zsp', JSON.stringify(request_data))
        .then((result) => {
          console.log(result.data)
          if(result.data.err_no==0){
            for(var i = 0;i<this.video_list.length;i+=1){
              if(this.video_list[i].sid==sid){
                this.video_list[i]=result.data
                console.log("check result success")
                this.waiting_num = -1
                this.waiting_time = -1
                //this.orderInfo()
                this.checkResult()
                return
              }
            }
          } else if(result.data.err_no==1){
            this.waiting_time = result.data.waiting_time
            this.waiting_num = result.data.waiting_num
            var that = this
            setTimeout(function () {
              that.checkResult()
            }, that.waiting_time*1000)
          }
        }).catch((error) => {
          console.log(error)
        })
    },
  }
}
</script>
  
<style>
.horizontal {
  flex-direction: row;
  display: flex;
  position: relative;
  flex-wrap: wrap;
  align-items: flex-start;
}

.title {
  text-align: center;
  margin-top: 10rem;
  padding: 0 10rem;
  font-size: 18rem;
  width: 220rem;
  color: #222222;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.waitingImg {
  display: block;
  width: 40rem;
  height: 40rem;
  margin:60rem auto;
  animation: rotateImg 8s linear infinite;
}
@keyframes rotateImg {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .3);
  z-index: 9999;

  width: 100%;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>